import React, { memo } from "react";
import { Card, Tabs } from "antd";
import { StickyContainer, Sticky } from "react-sticky";
import KPIReport from "./kpiReport";

const { TabPane } = Tabs;

const KPIData = () => {
  const renderTabBar = (props, DefaultTabBar) => (
    <Sticky bottomOffset={80}>
      {({ style }) => (
        <DefaultTabBar
          {...props}
          style={{ ...style, zIndex: 1, background: "#fff" }}
        />
      )}
    </Sticky>
  );

  return (
    <Card>
      <StickyContainer>
        <Tabs defaultActiveKey="1" renderTabBar={renderTabBar}>
          <TabPane tab="KPI Report" key="1">
            <KPIReport />
          </TabPane>
        </Tabs>
      </StickyContainer>
    </Card>
  );
};

export default memo(KPIData);
